export const wrapperSx = {
  paddingTop: '10px',
  paddingBottom: '10px',
  height: 'auto',                 // ocupa el viewport
  overflow: 'hidden',               // evita scroll del body
  display: 'grid',
  gridTemplateRows: 'auto 1fr',     // header + contenido
  bgcolor: 'grey.100',
}

export const pageSx = {
  display: 'grid',
  placeItems: 'center',

  // "Hoja"
  '& .page': {
    width: '210mm',
    background: '#fff',
    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    borderRadius: '12px',
  },

  // Área que scrollea (padre del editor)
  '& #editor-scroll': {
    height: 'min(297mm, 75dvh)',    // alto visible ajusta a gusto
    overflowY: 'auto',              // SOLO aquí hay scroll
    overscrollBehavior: 'contain',
  },

  // Quita bordes del tema Snow
  '& .ql-container.ql-snow': { border: 'none !important' },

  // Estilo del contenido
  '& #editor-scroll .ql-editor': {
    minHeight: '100%',
    padding: '20mm',
    lineHeight: 1.55,
  },

  // Imágenes pegadas grandes no rompan el layout
  '& #editor-scroll .ql-editor img': {
    maxWidth: '100%',
    height: 'auto',
  },

  // Responsive
  '@media (max-width: 900px)': {
    '& .page': { width: '100%' },
    '& #editor-scroll .ql-editor': { padding: '16px' },
    '& #editor-scroll': { height: '70vh' },
  },
}

export const placeholderHa = "                 Escribe aquí la hoja de atencion..."

/*
const PAGE_W = '210mm';   // A4
const PAGE_H = '297mm';   // A4
const PADDING = '20mm';   // margen interno
const SCALE = 1;       // ← hazla “más pequeña” (0.7–0.9)

export const wrapperSx = {
  height: '150%',
  overflow: 'hidden',                // evita scroll del body
  display: 'grid',
  placeItems: 'center',
  bgcolor: 'white',
  p: 3,
}

export const pageSx = {
// Quita borde del tema Snow
  '& .ql-container.ql-snow': { border: 'none !important' },

  // Viewport que reserva el tamaño ESCALADO (lo visible)
  '& .page-viewport': {
    width: `calc(${PAGE_W} * ${SCALE})`,
    height: `calc(${PAGE_H} * ${SCALE})`,
    overflow: 'hidden',
  },

  // La "hoja" en tamaño A4 real, pero escalada visualmente
  '& .page': {
    width: PAGE_W,
    height: PAGE_H,
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    transform: `scale(${SCALE})`,
    transformOrigin: 'top center',
  },

  // Área que scrollea (contenido dentro de la hoja)
  '& #editor-scroll': {
    height: `calc(${PAGE_H} - 2 * ${PADDING})`,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },

  // Estilo del contenido del editor
  '& #editor-scroll .ql-editor': {
    minHeight: '100%',
    padding: PADDING,
    lineHeight: 1.55,
  },

  // Imágenes pegadas grandes no rompan el layout
  '& #editor-scroll .ql-editor img': {
    maxWidth: '100%',
    height: 'auto',
  },

  // Responsive
  '@media (max-width: 900px)': {
    '& .page-viewport': {
      width: '100%',
      height: 'auto',
    },
    '& .page': {
      transform: 'scale(0.7)',
    },
    '& #editor-scroll .ql-editor': { padding: '16px' },
  }
  
}

export const placeholderHa = "                 Escribe aquí la hoja de atencion..."
*/